<template>
  <el-dialog :visible.sync="visible" title="修改游戏次数" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="num" label="游戏次数">
        <el-input v-model="dataForm.num" placeholder="游戏次数"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import Qs from 'qs';
  import debounce from 'lodash/debounce'
  import Url from '@/views/crs/util/url'
  export default {
    props: ['itemDrawId','account','oldNum'],
    data () {
      return {
        visible: false,
        dataForm: {
          gameRankId: '',
          account: '',
          num: ''
        }
      }
    },
    computed: {
      dataRule () {
        return {
          num: [
            { required: true, message: this.$t('validate.required'), trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init () {
        this.visible = true
        this.dataForm.num= this.oldNum
        this.dataForm.gameRankId= this.itemDrawId
        this.dataForm.account= this.account
      },
      // 表单提交
      dataFormSubmitHandle: debounce(function () {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          console.log(this.dataForm)
          this.$axios({
            headers:{'Content-Type':'application/x-www-form-urlencoded'},
            method: 'post',
            url:Url.gameRank.base+'/activity/gameRankUser/updateGameNum', 
            data:Qs.stringify(this.dataForm)
          }).then(res => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          }).catch(() => {})
        })
      }, 1000, { 'leading': true, 'trailing': false })
    }
  }
</script>